export const SUB_NAV = [
  { name:'常用工具', typeCode:'cygj', node:'tool' },
  { name:'数据分析', typeCode:'sjfx', node:'theDataAnalysis' },//domainNameRegistration  域名注册
  { name:'数据可视化', typeCode:'sjksh', node:'dataDisualization' }
]
